import clsx from 'clsx';
import Store from '../Store';
import * as React from 'react';
import { observer } from 'mobx-react';
import { activeTabPageClassName } from '../Types';
import { findLink } from '../../../../../../../../../../../../../LinkyLinky';
import { AlreadyTranslated } from '@execonline-inc/translations';

export interface Props {
  store: Store;
}

const SchoolPartners: React.FC<Props> = ({ store }) => {
  return (
    <div
      id="schoolPartners"
      className={clsx(
        activeTabPageClassName(store.state, 'schoolPartners'),
        'max-h-[57vh] overflow-auto px-11',
      )}
      data-intercom-target="school-partners-tab-page"
    >
      {store.resource.payload.schoolPartners.map((schoolPartner, i) => (
        <div
          className="border-b-1 border-solid py-10 last:mb-0 last:border-b-0"
          key={schoolPartner.payload.id}
          data-intercom-target={`school-partner-${i + 1}`}
        >
          <h3 className="mb-6 text-xl font-medium">
            <AlreadyTranslated content={schoolPartner.payload.name} />
          </h3>
          <div className="flex">
            {findLink('logo-on-white', schoolPartner.links)
              .map((url) => (
                <div className="flex basis-1/2 flex-col">
                  <img className="w-3/5" src={url.href} alt={schoolPartner.payload.name.text} />
                </div>
              ))
              .getOrElse(() => (
                <></>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default observer(SchoolPartners);
